<template>
  <div class="wty-style" style="padding-left: 50px;">
    选中： {{ names }}
    <div class="wty-style-item"></div>

    <div style="margin-right:10px" v-if="names == 'canvas'">
      <el-switch v-model="unit" active-text="px" inactive-text="mm">
      </el-switch>
    </div>
    <div
      style="margin-right:10px"
      v-if="names == 'i-text' || names == 'textbox' || names == 'text'"
    >
      <el-select
        @change="fillChange('fontFamily')"
        size="small"
        :style="`font-family:'${styleInfo.fontFamily}' !important;`"
        v-model="styleInfo.fontFamily"
        placeholder="请选择字体"
      >
        <el-option
          :style="`font-family:'${item}'`"
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>
    <div style="margin-right:10px" v-if="names == 'i-text'">
      <el-input
        placeholder="内容"
        size="small"
        v-model="styleInfo.text"
        type="text"
        style="width: 120px !important;"
        @change="fillChange('text')"
      ><template slot="prepend">内容</template>
        <!-- 
        <template slot="append">{{$store.state.canvas.unit}}</template> -->
      </el-input>
    </div>
    <div v-if="styleInfoEx5.width&&styleInfoEx5.height">
      <el-input
        placeholder="宽"
        size="small"
        v-model="styleInfoEx5.width"
        type="number"
        style="width: 120px !important;"
        @change="flushed('width')"
      >
        <template slot="prepend">宽</template>
        <template slot="append">{{$store.state.canvas.unit}}</template>
      </el-input>

      <el-input
        v-if="names != 'i-text' && names != 'textbox' && names != 'text'"
        style="margin:0 20px;width: 120px !important;"
        size="small"
        v-model="styleInfoEx5.height"
        placeholder="高"
        type="number"
        @change="flushed('height')"
      >
        <template slot="prepend">高</template>
        <template slot="append">{{$store.state.canvas.unit}}</template>
      </el-input>
    </div>
    <div class=" wty-style">
      <el-tooltip
        v-if="false"
        class="item"
        effect="dark"
        :content="
          names == 'i-text' || names == 'textbox' ? '文本颜色' : '背景颜色'
        "
        placement="bottom"
      >
        <el-color-picker
          size="mini"
          v-model="styleInfo.fill"
          show-alpha
          :predefine="predefineColors"
          @change="fillChange('fill')"
        >
        </el-color-picker>
      </el-tooltip>
    </div>
    <div
      class="wty-style"
      v-if="names == 'i-text' || names == 'textbox' || names == 'image'"
    >
      <div v-if="names == 'i-text' || names == 'textbox' || names == 'image'">
        <el-input
          type="number"
          size="small"
          style="padding:0 0 0 5px !important;width: 120px !important;"
          @change="flushed('left')"
          v-model="styleInfoEx5.left"
        >
          <template slot="append">{{$store.state.canvas.unit}}</template>
          <template slot="prepend">x</template>
        </el-input>
      </div>
      <div v-if="names == 'i-text' || names == 'textbox' || names == 'image'">
        <el-input
          type="number"
          size="small"
          style="padding:0 0 0 5px !important;width: 120px !important;"
          @change="flushed('top')"
          v-model="styleInfoEx5.top"
        >
          <template slot="prepend">y</template>
          <template slot="append">{{$store.state.canvas.unit}}</template>
        </el-input>
      </div>
      <div v-if="names == 'i-text' || names == 'textbox'">
        <el-input
          type="number"
          size="small"
          style="padding:0 0 0 5px !important;width: 120px !important;"
          @change="flushed('fontSize')"
          v-model="styleInfo.fontSize"
        >
          <template slot="prepend">字号</template>
        </el-input>
      </div>
      <div class=" wty-style" v-if="names == 'i-text' || names == 'textbox'">
        <div
          v-for="item in iconList"
          v-bind:key="item.id"
          class=" wty-style wty-style-item-bi"
          :class="styleInfo[item.id] ? 'clicked' : ''"
          @click="beforeChange(item.id)"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.content"
            placement="bottom"
          >
            <i :style="item.text_style">{{ item.text }}</i>
          </el-tooltip>
        </div>
      </div>

      <div
        @click="deleteEle"
        class="wty-style-item wty-style wty-style-item-bi"
      >
        <i class="el-icon-delete-solid"></i>
      </div>
    </div>
  </div>
</template>

<script>
// import { number } from "echarts";
import { mapMutations } from 'vuex';
export default {
  props: ["keys", "element"],
  data() {
    return {
      fill: "rgba(255, 69, 0, 0.68)",
      backgroundColor: "rgba(255, 69, 0, 0.68)",
      options: [
        "幼圆",
        "隶书",
        "楷体",
        "黑体",
        "锐字真言体免费商用",
        "思源黑体",
        "方正兰亭超细黑简体",
        "阿里汉仪智能黑体",
        "TangXianBinSong",
        "Segoe Scropt",
        "Times New Roman",
        "Arial Unicode MS",
        "Ink Free",
        "Goudy Stout"
      ],

      predefineColors: [
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
        "rgba(255, 69, 0, 0.68)",
        "rgb(255, 120, 0)",
        "hsv(51, 100, 98)",
        "hsva(120, 40, 94, 0.5)",
        "hsl(181, 100%, 37%)",
        "hsla(209, 100%, 56%, 0.73)",
        "#c7158577"
      ],
      /* icon */
      iconList: [
        {
          id: "underline",
          content: "下划线",
          text: "T",
          text_style: "font-weight:700;text-decoration:underline;"
        },
        {
          id: "linethrough",
          content: "删除线",
          text: "T",
          text_style: "font-weight:700;text-decoration:line-through;"
        }
      ],
      names: "",
      styleInfo: {
        width: "",
        height: "",
        fontWeight: "",
        fontSize: 16,
        fontFamily: "",
        input: "",
        fill: "",
        strong: false,
        italic: false,
        underline: false,
        linethrough: false,
        backgroundColor: "",
        timer: null,
        top: "",
        left: "",
        text:""
      },
      styleInfoEx5: {
        width: "",
        height: "",
        top: "",
        left: ""
      }
    };
  },
  watch:{
    unit(nunit,ounit){
      if(this.nunit){
        this.styleInfoEx5.watch = this.styleInfo.width;
        this.styleInfoEx5.height = this.styleInfo.height;
        this.styleInfoEx5.left = this.styleInfo.left;
        this.styleInfoEx5.top = this.styleInfo.top;
      }else{
        this.styleInfoEx5.watch = this.styleInfo.width/5;
        this.styleInfoEx5.height = this.styleInfo.height/5;
        this.styleInfoEx5.left = this.styleInfo.left/5;
        this.styleInfoEx5.top = this.styleInfo.top/5;
      }

      /* this.flushed("width");
      this.flushed("height");
      this.flushed("top");
      this.flushed("left"); */
    }
  },
  computed: {
    unit: {
      get() {
        return this.$store.state.canvas.unit=="px"?true:false;
      },
      set(value) {
        this.CHANGECOMPUTE(value);
      }
    }
  },
  /*  watch: {
    styleInfo: {
      handler(nstyle, ostyle) {

        clearTimeout(this.timer); //防抖
        this.timer = setTimeout(() => {
          console.log(nstyle);
          this.$emit("styleReturn", nstyle);
        }, 1500);
      },
      deep: true
    }
  }, */
  mounted() {
    this.names = this.element;
  },
  methods: {
    ...mapMutations("canvas",["CHANGECOMPUTE"]),

    /**
     * 颜色修改触发styleReturn
     * @param {*} key
     */
    fillChange(key) {
      // console.log("fill", this.styleInfo.fill);
      this.$emit("styleReturn", {
        names: this.names,
        key,
        res: this.styleInfo[key]
      });
    },

    //TODO:9-11修改
    /**
     * 宽高上左修改触发
     * @param {*} key
     *
     */
    flushed(key) {
      if (key == "width" || key == "height" || key == "top" || key == "left") {
        if(!this.unit){
          this.styleInfo[key] = Number(Math.trunc(this.styleInfoEx5[key])) * 5;
        }else{
          this.styleInfo[key] = Number(Math.trunc(this.styleInfoEx5[key]));
        }
        
      }
      this.$emit("styleReturn", {
        names: this.names,
        key,
        res: this.styleInfo[key]
      });
    },
    styleChange(names, info) {
      if (names == "canvas" && info == undefined) {
        this.names = "canvas";
        return;
      }
      this.names = names;
      for (let key in info) {
        switch (key) {
          case "height":
          case "width":
          case "top":
          case "left":
            //TODO: this.styleInfoEx5[key] = Math.trunc(Number(info[key] / 5));
            if(!this.unit){
              this.styleInfoEx5[key] = Math.trunc(Number(info[key] / 5));
            }else{
              this.styleInfoEx5[key] = Math.trunc(Number(info[key]));
            }
            if (
              (names == "image" && key == "height") ||
              (names == "image" && key == "width")
            ) {
              this.styleInfoEx5[key] = this.styleInfoEx5[key];
            }
            break;
          default:
            this.styleInfo[key] = info[key];
            break;
        }
        if (info["fontWeight"] == "600") {
          this.styleInfo.strong = true;
        }
        if (info["fontStyle"] == "italic") {
          this.styleInfo.italic = true;
        }
        if (info["underline"] == true) {
          this.styleInfo.underline = true;
        }
        if (info["linethrough"] == true) {
          this.styleInfo.linethrough = true;
        }
      }
    },
    beforeChange(key) {
      this.styleInfo[key] = !this.styleInfo[key];
      if (key == "underline" || key == "linethrough") {
        this.$emit("styleReturn", {
          names: this.names,
          key,
          res: this.styleInfo[key]
        });
      }
      if (key == "strong" && this.styleInfo[key] == true) {
        this.$emit("styleReturn", {
          names: this.names,
          key: "fontWeight",
          res: "600"
        });
      } else if (key == "strong" && this.styleInfo[key] == false) {
        this.$emit("styleReturn", {
          names: this.names,
          key: "fontWeight",
          res: "normal"
        });
      }
      if (key == "italic" && this.styleInfo[key] == true) {
        this.$emit("styleReturn", {
          names: this.names,
          key: "fontStyle",
          res: key
        });
      } else if (key == "italic" && this.styleInfo[key] == false) {
        this.$emit("styleReturn", {
          names: this.names,
          key: "fontStyle",
          res: "normal"
        });
      }
    },
    deleteEle() {
      this.$emit("styleReturn", { names: this.names, key: "remove", res: "" });
    }
  }
};
</script>
<style lang="less" scoped>
.wty-style {
  display: flex;
  align-items: center;
  height: 40px;
  // min-width: 40px;
  &-item {
    margin: 0 10px;
    cursor: pointer;
  }
  &-item-bi {
    width: 40px;
    height: 40px;
    margin-left: 10px;
    user-select: none;
    text-align: center;
    justify-content: center;
    cursor: pointer;
  }
}
.clicked {
  background-color: @bg-show-deep;
  border-radius: 3px;
}
/deep/.el-input {
  width: 150px !important;
}
/deep/.el-input__inner {
  padding: 0px 0px 0px 5px;
}
/deep/.el-input-group__prepend {
  padding: 5px;
}
/deep/.el-input-group__append {
  padding: 5px;
}
</style>
